import React from "react";
import { Auth } from "aws-amplify";
import "./ConfirmationSignup.css";
import { useHistory } from "react-router-dom";
import AppJS from "../../../assets/app/AppJS";
import AppCSS from "../../../assets/app/AppCSS";
import { currentYear } from "../../../utils/utils";
import { s3BaseURL } from "../../../utils/constantInformation";

function ConfirmationSignup() {
  const history = useHistory();
  console.log("History");
  console.log(history);
  const username = history.location.state.username;
  const [authCode, setAuthCode] = React.useState();
  async function confirmSignUp(username, code) {
    try {
      await Auth.confirmSignUp(username, code);
    } catch (error) {
      console.log("error confirming sign up", error);
    }
  }
  const handleChange = (e) => {
    setAuthCode(e.target.value.trim());
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    console.log(authCode);
    // ... submit to API or something
    if (authCode == 0) {
      alert("Auth Code cannot be empty!");
    } else {
      console.log("Yay");
      const resp = confirmSignUp(username, authCode);
      console.log("Resp");
      console.log(resp);
    }
  };

  return (
    <>
      <AppJS />
      <AppCSS />
      <div className="bg-black signin__main">
        <div className="card bg-dark">
          <div className="card-body">
            <div className="text-center">
              <img
                className="signin__logo"
                src={s3BaseURL + "res/spordia_logo.png"}
                alt="spordia-logo"
              />
            </div>
            <h2 className="card-title text-center text-white">
              Confirm Sign Up
            </h2>
            <p className="card-title text-center text-white m-2">
              Please check your email and provide the Authorization Code Below
            </p>
            <form action="">
              <div class="form-group">
                <input
                  class="form-control form-control-lg mb-3 bg-dark text-white"
                  type="text"
                  placeholder="Verification Code"
                  onChange={handleChange}
                ></input>
                <button
                  type="submit"
                  onClick={handleSubmit}
                  class="btn btn-primary btn-lg btn-block"
                >
                  Verify
                </button>
              </div>
            </form>

            <p className="text-center text-white">
              <small>© All rights reserved. Spordia {currentYear}</small>
            </p>
          </div>
        </div>
      </div>
    </>
  );
}

export default ConfirmationSignup;
